import React from 'react'
import Routes from './Routes'
// import { Container} from 'semantic-ui-react'

export default () => (
    <div>
        <div>
            <Routes />
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/App.js